require('./bootstrap');

import store from './store';
import vuetify from './plugins/vuetify';
import {buildi18nObject} from "./i18n";
import router from './router';

window.Vue = require('vue');
window.store = store;
window.router = router;
window.Event = new Vue();

const lang = window.appLocale || 'es';


// Horizontal Scroll plugin
import HorizontalScroll from 'vue-horizontal-scroll';

// Toast
import VueToastr from "vue-toastr";
Vue.use(VueToastr);

// Currency filter plugin
require('./plugins/currency');

// Load Script plugin
require('./plugins/loadScript');

// Vue Components
require('./components/components');

// Filters
require('./utils/filters/date');
require('./utils/filters/time');

// Global Event Bus
window.Events = new Vue();
Vue.prototype.$eventHub = new Vue();

// Add the router to every vue instance.
Vue.prototype.router = router;
Vue.prototype.goBack = () => {
  router.go(-1);
};

Vue.filter('mo', (value) => {
  if (!value) return '';
  value = value.toString();
  return value.charAt(0).toUpperCase() + value.slice(1)
});

// This callback runs before every route change, including on page load.
router.beforeEach((to, from, next) => {
  // This goes through the matched routes from last to first, finding the closest route with a title.
  // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);

  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);
  const previousNearestWithMeta = from.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

  // If a route with a title was found, set the document (page) title to that value.
  if (nearestWithTitle) document.title = nearestWithTitle.meta.title;

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));

  // Skip rendering meta tags if there are none.
  if (!nearestWithMeta) return next();

  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags.map(tagDef => {
    const tag = document.createElement('meta');

    Object.keys(tagDef).forEach(key => {
      tag.setAttribute(key, tagDef[key]);
    });

    // We use this to track which meta tags we create, so we don't interfere with other ones.
    tag.setAttribute('data-vue-router-controlled', '');

    return tag;
  })
    // Add the meta tags to the document head.
    .forEach(tag => document.head.appendChild(tag));

  next();
});




fetch(`/lang/${lang}.json`).then(res => {
  return res.json()
}).then(messages => {

  const i18n = buildi18nObject(lang, messages);
  window.i18n = i18n;
  const app = new Vue({
    el: '#app',
    components: {
      HorizontalScroll
    },
    i18n,
    router,
    vuetify,
    store: store
  });

  window.app = app;
})

